export default {
    'create-user': 'إنشاء مستخدم',
    'edit-user': 'تعديل المستخدم',
    active: 'نشط',
    unactive: 'متوقف',
    allowed: 'مسموح',
    'not-allowed': 'غير مسموح',
    username: 'اسم المستخدم',
    password: 'كلمة السر',
    'have-permission-to-create-a-file': 'يملك صلاحية إنشاء ملف',
    save: 'حفظ',
    cancel: 'إلغاء',

    'delete-user': 'حذف مُستخدم',
    'are-you-sure-you-want-to-delete-the-user-$': 'هل أنت متأكد من حذف المستخدم {username}؟',
    'change-account-state': 'تعديل حالة الحساب',
    'are-you-sure-you-want-to': 'هل أنت متأكد من',
    'deactivate': 'إيقاف',
    'activate': 'إعادة تنشيط',
    'account': 'حساب {username}؟',
    
    'files-which': 'الملفات التي يملك',
    'has-access-to-it': 'صلاحية وصول لها',

    temp: {
        'financial-file': 'الملف المالي',
        permission: 'الصلاحية',
    },

    ok: 'موافق',
    confirm: 'مُتابعة',

    'security-alert': 'تنبيه أمني',
    'changing-your-password-required-logout-then-you-can-login': 'في حال تغيير كلمة السر الخاصة بك، سيتوجب عليك تسجيل الخروج عٌقبها ومٌعاودة تسجبل الدخول بكلمة السر الجديدة.',

    headers: {
        username: 'اسم المستخدم',
        'permission-to-create-a-file': 'سماحية إنشاء ملف',
        'account-state': 'حالة الحساب',
        actions: 'الأحداث',
    },

    permissions: {
        viewer: 'مُتصفح بيانات',
        accountant: 'مُحاسب',
        advancedAccountant: 'محاسب متقدم',
        warehouseKeeper: 'أمين مستودع',
        warehouseManager: 'مدير مستودع'
    },

    'there-is-a-user-with-the-same-name': 'هناك مستخدم آخر بنفس الاسم',

    // saad's work
    addPermission: 'إضافة صلاحية',
    NoAddedPermission: 'لم يتم إضافة صلاحية'
}